import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const CATEGORIES = [
  "Climatizzazione",
  "Sistemi d'allarme",
  "Antincendio",
  "Sistemi di sicurezza",
  "Settore elettrico",
  "Automazione",
  "Luce e gas",
  "Fotovoltaico",
  "Idraulica",
  "Altro",
];

// type: "photo" = image cover, "brand" = brand text card, "icon" = themed icon card
export const SERVICE_CARDS = {
  "Climatizzazione": { type: "logo", url: "/assets/daikin.png", subtitle: "Partner ufficiale", tag: "Condizionatori & pompe di calore" },
  "Sistemi d'allarme": { type: "photo", url: "https://images.unsplash.com/photo-1558002038-1055907df827?crop=entropy&cs=srgb&fm=jpg&q=85&w=800" },
  "Antincendio": { type: "icon", icon: "Flame", bg: "from-red-600 via-orange-600 to-amber-500", subtitle: "Rilevazione fumo & spegnimento", tag: "Sistemi certificati EN54" },
  "Sistemi di sicurezza": { type: "photo", url: "https://images.unsplash.com/photo-1730967844913-29eb5cae5f34?crop=entropy&cs=srgb&fm=jpg&q=85&w=800" },
  "Settore elettrico": { type: "photo", url: "https://images.unsplash.com/photo-1615774925655-a0e97fc85c14?crop=entropy&cs=srgb&fm=jpg&q=85&w=800" },
  "Automazione": { type: "photo", url: "https://images.unsplash.com/photo-1716380703770-c3dd70781e82?crop=entropy&cs=srgb&fm=jpg&q=85&w=800" },
  "Luce e gas": { type: "logo", url: "/assets/eko360.png", subtitle: "Fornitore partner", tag: "Luce · Gas · Mobilità" },
  "Fotovoltaico": { type: "photo", url: "https://images.unsplash.com/flagged/photo-1566838616631-f2618f74a6a2?crop=entropy&cs=srgb&fm=jpg&q=85&w=800" },
  "Idraulica": { type: "photo", url: "https://images.unsplash.com/photo-1607472586893-edb57bdc0e39?crop=entropy&cs=srgb&fm=jpg&q=85&w=800" },
  "Altro": { type: "photo", url: "https://images.unsplash.com/photo-1615774925655-a0e97fc85c14?crop=entropy&cs=srgb&fm=jpg&q=85&w=800" },
};

// Keep a URL map for pages that show hero backgrounds (fallback to generic)
export const SERVICE_IMAGES = Object.fromEntries(
  Object.entries(SERVICE_CARDS).map(([k, v]) => [k, v.type === "photo" ? v.url : "https://images.unsplash.com/photo-1624397640148-949b1732bb0a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600"])
);

export const PERIODS = [
  { value: "7", label: "Ultimi 7 giorni" },
  { value: "14", label: "Ultimi 14 giorni" },
  { value: "30", label: "Ultimi 30 giorni" },
  { value: "60", label: "Ultimi 60 giorni" },
  { value: "180", label: "Ultimi 6 mesi" },
  { value: "365", label: "Ultimo anno" },
  { value: "730", label: "Ultimi 2 anni" },
  { value: "all", label: "Sempre" },
];
